<template>
	<div class="mx-auto max-w-screen-lg my-20 px-10">
		<div class="flex flex-row items-center ml-4">
			<AppIcon />
			<p class="text-4xl font-visby ml-4">Amy</p>
		</div>
		<div class="mx-auto max-w-screen-lg">
			<BetaSignUp />
		</div>
	</div>
</template>